import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getSessionId, removeSessionId } from '../../lib/storage';
import { me } from '../../lib/api';
import { userNotLoggedIn, userDataLoaded } from '../../redux/actions';
import { isProd } from '../../lib/config';

import { Header, Footer } from './';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../layout.css';
import './Base.css';

class Base extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    headerColor: PropTypes.string,
    hideFooter: PropTypes.bool,
    hideLogoUntilY: PropTypes.number,
  };

  static defaultProps = {
    headerColor: 'purple',
    hideFooter: false,
  };

  state = {
    y: 0,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.setState({ y: window.scrollY });
    const { userIsLoaded, actionUserNotLoggedIn, actionUserDataLoaded } = this.props;
    const sessionId = getSessionId();

    if (!userIsLoaded) {
      if (!getSessionId()) {
        actionUserNotLoggedIn();
        return;
      }

      me(sessionId)
        .then((data) => {
          actionUserDataLoaded(data);
        })
        .catch((ex) => {
          if (ex.statusCode === 401) {
            removeSessionId();
          } else {
            console.error(ex);
          }
          actionUserNotLoggedIn();
        });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    this.setState({
      y: window.scrollY,
    });
  };

  render() {
    const { hideFooter, hideLogoUntilY, ...headerProps } = this.props;
    const { headerColor } = headerProps;
    const { y } = this.state;
    return (
      <>
        <Header {...{ ...headerProps, hideLogo: hideLogoUntilY && y < hideLogoUntilY }} />
        <main className={`bg-${headerColor}`}>{this.props.children}</main>
        {!hideFooter && <Footer />}
        {!isProd && <div className="env-indication" />}
      </>
    );
  }
}

export default connect(({ user: { userIsLoaded } }) => ({ userIsLoaded }), {
  actionUserNotLoggedIn: userNotLoggedIn,
  actionUserDataLoaded: userDataLoaded,
})(Base);
